import enCompanySurveysAnalytics from './en';
import ruCompanySurveysAnalytics from './ru';

export default {
  en: {
    ...enCompanySurveysAnalytics,
  },
  ru: {
    ...ruCompanySurveysAnalytics,
  },
};
